/*
 * ORA: pagina prodotto singolo (sections/ora-product-builder.liquid).
 * Dati veri dal JSON della sezione: opzioni, varianti, foto, pezzi e set della stessa linea.
 * Tendine con il markup di snippets/ora-size-dropdown.liquid: apertura, tastiera e scelta le gestisce
 * assets/ora-size-dropdown.js; qui si legge la scelta da aria-selected (come la pagina set).
 */
(() => {
  if (window.oraProductBuilder) return;
  window.oraProductBuilder = true;

  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');
  const ARW = '<svg class="ora-dd__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  const GO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  const ANG = [['tre quarti', 45], ['fronte', 0], ['profilo', 90], ['lato', 90], ['retro', 180]];
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const slug = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const low = (s) => String(s || '').trim().toLowerCase();
  const nodash = (s) => String(s || '').replace(/(\d+)\s*[-–—]\s*(\d+)/g, 'da $1 a $2').replace(/\s[-–—]\s/g, ', ').replace(/[-–—]/g, ' ');

  /** Varianti del nome colore nel nome file (Pynk Peach anche come pink-peach). */
  function colorSlugs(n) {
    const s = slug(n);
    const out = [s];
    if (s.includes('pynk')) out.push(s.replace('pynk', 'pink'));
    return out;
  }
  /** Lunghezza del colore trovato nel nome file (0 se non c'è): vince il più lungo. */
  function colorHit(key, n) {
    const k = '-' + slug(key) + '-';
    return colorSlugs(n).reduce((m, c) => (k.includes('-' + c + '-') ? Math.max(m, c.length) : m), 0);
  }
  /** Righe delle viste: file | vista | gradi */
  function parseViews(txt) {
    return String(txt || '')
      .split(/\r?\n/)
      .map((l) => l.split('|').map((x) => x.trim()))
      .filter((c) => c.length >= 2 && c[0])
      .map((c, i) => ({ k: c[0].replace(/\.[a-z0-9]+$/i, ''), label: c[1], deg: c[2] !== undefined && c[2] !== '' && !isNaN(+c[2]) ? +c[2] : null, i }));
  }
  function angleOf(label) {
    const l = low(label);
    const hit = ANG.find(([w]) => l === w || l.startsWith(w + ' ') || l.startsWith(w + ','));
    return hit ? hit[1] : null;
  }

  function init(root) {
    const D = JSON.parse(root.querySelector('[data-orp-data]').textContent);
    const q = (s) => root.querySelector(s);
    const qa = (s) => Array.from(root.querySelectorAll(s));
    const T = D.texts;
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency });
    const money = (c) => fmt.format(c / 100);
    const uid = 'orp' + D.section.replace(/[^a-z0-9]/gi, '');
    const CI = D.ci;
    const OPTS = D.opts;
    const DDI = OPTS.map((o, i) => i).filter((i) => i !== CI);
    const COLS = D.colors.length ? D.colors : [{ n: null, h: '' }];
    const ROWS = parseViews(D.views);

    const rowFor = (k) => ROWS.find((r) => k === r.k || k.startsWith(r.k + '_'));

    /* ---------- foto per colore ---------- */
    const ownerOf = {};
    D.media.forEach((m) => {
      let best = null, len = 0;
      COLS.forEach((c) => { if (!c.n) return; const h = colorHit(m.k, c.n); if (h > len) { len = h; best = c.n; } });
      if (best) ownerOf[m.id] = best;
    });
    D.v.forEach((v) => { if (CI > -1 && v.m && !ownerOf[v.m]) ownerOf[v.m] = v.o[CI]; });
    const setFor = (c) => {
      if (!c) return null;
      const end = ' ' + low(c);
      const all = D.sets.filter((s) => low(s.t).endsWith(end));
      return all.find((s) => s.a) || all[0] || null;
    };
    function framesFor(c) {
      let list = D.media.filter((m) => (c ? ownerOf[m.id] === c : true));
      if (!list.length && c) { const s = setFor(c); if (s) list = s.m.map((m) => ({ k: m.k, u: m.u, t: m.t, a: '' })); }
      if (!list.length) list = D.media.filter((m) => !ownerOf[m.id]);
      if (!list.length) list = D.media.slice();
      const out = list.map((m, n) => {
        const r = rowFor(m.k);
        const alt = m.a && m.a.length <= 28 && low(m.a) !== low(D.title) ? m.a : '';
        const label = alt || (r && r.label) || '';
        const deg = r && r.deg !== null ? r.deg : alt ? angleOf(alt) : null;
        return { k: m.k, u: m.u, t: m.t, label, deg, o: r ? r.i : 1000 + n };
      });
      out.sort((a, b) => a.o - b.o);
      out.forEach((f, n) => { if (!f.label) f.label = 'Vista ' + (n + 1); });
      return out;
    }

    /* ---------- stato ---------- */
    const S = { c: null, sz: {}, vi: 0 };
    const vFor = (c, sz) => D.v.find((v) => OPTS.every((o, i) => (i === CI ? v.o[i] === c : v.o[i] === sz[i])));
    const vOfColor = (c) => D.v.filter((v) => CI < 0 || v.o[CI] === c);
    const availVal = (c, i, val) => vOfColor(c).some((v) => v.o[i] === val && v.a);
    const complete = () => DDI.every((i) => S.sz[i] != null);
    const current = () => (complete() ? vFor(S.c, S.sz) : null);

    const sel = D.sel ? D.v.find((v) => v.id === D.sel) : null;
    if (sel) {
      if (CI > -1) S.c = sel.o[CI];
      DDI.forEach((i) => { S.sz[i] = sel.o[i]; });
    } else if (CI > -1) {
      const first = D.v.find((v) => v.a) || D.v[0];
      S.c = first ? first.o[CI] : COLS[0].n;
    }
    // nel colore iniziale una taglia esaurita non resta scelta
    DDI.forEach((i) => { if (S.sz[i] != null && !availVal(S.c, i, S.sz[i])) delete S.sz[i]; });

    /* ---------- palco foto ---------- */
    const stage = q('[data-orp-stage]');
    const fa = q('[data-orp-fa]'), fb = q('[data-orp-fb]');
    let front = fa;
    let FR = [];
    function showPhoto(src, alt) {
      if (front.getAttribute('src') === src) { front.alt = alt; return; }
      const back = front === fa ? fb : fa;
      back.alt = alt;
      back.src = src;
      const swap = () => { back.classList.add('is-on'); front.classList.remove('is-on'); front.alt = ''; front = back; };
      if (back.complete && back.naturalWidth) swap();
      else if (back.decode) back.decode().then(swap, swap);
      else back.onload = swap;
    }
    function renderViews() {
      q('[data-orp-views]').innerHTML = FR.length > 1 ? FR.map((f, i) => `<button type="button" data-vi="${i}" aria-pressed="${i === S.vi}">${esc(f.label)}</button>`).join('') : '';
    }
    /* ---------- dettagli numerati sulla foto ---------- */
    const PTS = String(D.points || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((c) => c.length >= 3 && c[0]).map((c) => { const xy = c[1].split(/[ ,;]+/).map(Number); return { k: c[0].replace(/\.[a-z0-9]+$/i, ''), x: xy[0], y: xy[1], t: c[2], d: c[3] || '' }; }).filter((p) => !isNaN(p.x) && !isNaN(p.y));
    const ptsEl = q('[data-orp-pts]'), ptg = q('[data-orp-ptgl]');
    let ptsOff = false, ptOpen = -1;
    function renderPts(k) {
      if (!ptsEl) return;
      const list = PTS.filter((p) => k === p.k || String(k).startsWith(p.k + '_'));
      ptOpen = -1;
      ptsEl.innerHTML = list.map((p, n) => `<button type="button" class="orp-pt${p.x <= 50 ? ' is-l' : ''}" style="left:${p.x}%;top:${p.y}%" data-pt="${n}" aria-expanded="false" aria-label="${esc(p.t)}"><i class="orp-pt-l" aria-hidden="true"></i><i class="orp-pt-o" aria-hidden="true"></i><span class="orp-pt-n">${String(n + 1).padStart(2, '0')}</span></button><div class="orp-ptc${p.x > 55 ? ' is-l' : ''}" style="left:${p.x}%;top:${p.y}%" data-ptc="${n}" hidden><b>${esc(p.t)}</b>${p.d ? `<p>${esc(p.d)}</p>` : ''}</div>`).join('');
      ptsEl.hidden = ptsOff || !list.length;
      if (ptg) ptg.hidden = !PTS.length;
      requestAnimationFrame(fitPts);
    }
    /* i numeri non coprono mai punti, logo, pulsanti, etichette o altri numeri: si spostano di lato o in alto e in basso */
    function fitPts() {
      if (!ptsEl || ptsEl.hidden || !ptsEl.children.length) return;
      const st = ptsEl.getBoundingClientRect();
      if (!st.width) return;
      const box = (e) => e && !e.hidden && e.offsetParent ? e.getBoundingClientRect() : null;
      const block = [q('[data-orp-ptgl]'), q('[data-orp-stl]'), q('[data-orp-views]')].map(box).filter(Boolean);
      const pts = [...ptsEl.querySelectorAll('.orp-pt')];
      pts.forEach((b) => { const r = b.getBoundingClientRect(); block.push({ left: r.left - 16, right: r.left + 16, top: r.top - 16, bottom: r.top + 16 }); });
      const hit = (r, o) => !(r.right + 4 < o.left || r.left - 4 > o.right || r.bottom + 4 < o.top || r.top - 4 > o.bottom);
      pts.forEach((b) => {
        const n = b.querySelector('.orp-pt-n'), ln = b.querySelector('.orp-pt-l');
        const pref = b.classList.contains('is-l') ? ['l', 'r'] : ['r', 'l'];
        let pick = null;
        for (const dy of [0, -40, 40, -80, 80, -120, 120]) {
          for (const sd of pref) {
            b.classList.toggle('is-l', sd === 'l'); b.style.setProperty('--dy', dy + 'px');
            const r = n.getBoundingClientRect();
            const inside = r.left >= st.left + 4 && r.right <= st.right - 4 && r.top >= st.top + 4 && r.bottom <= st.bottom - 4;
            if (inside && !block.some((o) => hit(r, o))) { pick = [sd, dy]; break; }
          }
          if (pick) break;
        }
        if (!pick) pick = [pref[0], 0];
        b.classList.toggle('is-l', pick[0] === 'l'); b.style.setProperty('--dy', pick[1] + 'px');
        block.push(n.getBoundingClientRect());
        const dx = pick[0] === 'l' ? -26 : 26, dy = pick[1];
        ln.style.width = Math.max(0, Math.hypot(dx, dy) - 6) + 'px';
        ln.style.transform = `rotate(${Math.atan2(dy, dx)}rad) translateX(6px)`;
      });
    }
    window.addEventListener('resize', () => requestAnimationFrame(fitPts), { passive: true });
    if (ptsEl) ptsEl.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pt]'); if (!b) return;
      const n = +b.dataset.pt; const o = ptOpen !== n;
      ptsEl.querySelectorAll('[data-ptc]').forEach((c) => { c.hidden = !(o && +c.dataset.ptc === n); });
      ptsEl.querySelectorAll('[data-pt]').forEach((x) => x.setAttribute('aria-expanded', String(o && +x.dataset.pt === n)));
      ptOpen = o ? n : -1;
    });
    document.addEventListener('click', (e) => { if (ptOpen > -1 && ptsEl && !ptsEl.contains(e.target)) { ptsEl.querySelectorAll('[data-ptc]').forEach((c) => { c.hidden = true; }); ptsEl.querySelectorAll('[data-pt]').forEach((x) => x.setAttribute('aria-expanded', 'false')); ptOpen = -1; } });
    if (ptg) ptg.addEventListener('click', () => { ptsOff = !ptsOff; ptg.setAttribute('aria-pressed', String(ptsOff)); q('[data-orp-ptglt]').textContent = ptsOff ? 'Mostra dettagli' : 'Nascondi dettagli'; ptsEl.hidden = ptsOff || !ptsEl.children.length; requestAnimationFrame(fitPts); });
    function setView(i) {
      if (!FR.length) return;
      S.vi = (i + FR.length) % FR.length;
      const f = FR[S.vi];
      showPhoto(f.u, `${D.title}${S.c ? ' ' + S.c : ''}, vista ${f.label}`);
      renderPts(f.k);
      const stl = q('[data-orp-stl]');
      stl.hidden = false;
      stl.textContent = [S.c, f.label].filter(Boolean).join(' · ');
      qa('[data-orp-views] button').forEach((b, k) => b.setAttribute('aria-pressed', String(k === S.vi)));
      const act = q(`[data-orp-views] button[data-vi="${S.vi}"]`);
      if (act) {
        const box = act.parentElement;
        const l = act.offsetLeft, r = l + act.offsetWidth;
        if (l < box.scrollLeft || r > box.scrollLeft + box.clientWidth) box.scrollTo({ left: l - 8, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }
    }
    q('[data-orp-views]').addEventListener('click', (e) => { const b = e.target.closest('button[data-vi]'); if (b) setView(+b.dataset.vi); });
    (() => {
      let x0 = null, y0 = 0;
      stage.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' || e.target.closest('button')) return; x0 = e.clientX; y0 = e.clientY; });
      stage.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) setView(S.vi + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', () => { x0 = null; });
    })();

    /* ---------- 01 colore ---------- */
    function noteFor(c) {
      if (!DDI.length) return vOfColor(c).some((v) => v.a) ? 'Disponibile' : T.soldOut;
      const i = DDI[0];
      const vals = OPTS[i].v;
      const out = vals.filter((val) => !availVal(c, i, val));
      if (out.length === vals.length) return T.soldOut;
      if (!out.length) return 'Tutte le taglie';
      if (out.length === 1) return 'Esaurita la ' + out[0];
      return 'Esaurite ' + out.slice(0, -1).join(', ') + ' e ' + out[out.length - 1];
    }
    const cols = q('[data-orp-cols]');
    function renderColors() {
      if (!cols) return;
      cols.innerHTML = COLS.map((c, k) => `<button type="button" class="ors-cc" data-k="${k}" aria-pressed="${c.n === S.c}"><i style="background:${esc(c.h || '#fff')}"></i><span><b>${esc(c.n)}</b><small>${esc(noteFor(c.n))}</small></span></button>`).join('');
    }
    if (cols) {
      cols.addEventListener('click', (e) => { const b = e.target.closest('button[data-k]'); if (b) setColor(COLS[+b.dataset.k].n); });
      cols.addEventListener('mouseover', (e) => {
        const b = e.target.closest('button[data-k]');
        if (!b || b.dataset.pre) return;
        b.dataset.pre = '1';
        const f = framesFor(COLS[+b.dataset.k].n)[0];
        if (f) { const im = new Image(); im.src = f.u; }
      });
    }

    /* ---------- tendine ---------- */
    const ddId = (i, val) => `${uid}-o${i}-${slug(val) || 'x'}`;
    function ddHTML(i, where) {
      const o = OPTS[i];
      const cur = S.sz[i];
      const id = `${uid}-${where}${i}`;
      const aria = o.l;
      return `<div class="ora-dd${where === 'b' ? ' ora-dd--compact ora-dd--up' : ''}" data-ora-dd data-orp-dd="${i}"><button type="button" class="ora-dd__btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="${id}" aria-label="${esc(aria)}: ${esc(cur || 'da scegliere')}"><span class="ora-dd__l">${esc(where === 'b' ? 'Taglia' : o.l)}</span><span class="ora-dd__v${cur ? '' : ' is-ph'}">${esc(cur || 'Scegli')}</span>${ARW}</button><ul class="ora-dd__list" role="listbox" id="${id}" tabindex="-1" aria-label="${esc(aria)}">${o.v
        .map((val, k) => {
          const a = availVal(S.c, i, val);
          return `<li role="option" id="${id}-${k}" data-value-id="${ddId(i, val)}" data-v="${esc(val)}" aria-selected="${val === cur}"${a ? '' : ' aria-disabled="true"'}>${a ? `<span>${esc(val)}</span>` : `<s>${esc(val)}</s><em>Esaurita</em>`}</li>`;
        })
        .join('')}</ul></div>`;
    }
    const dds = q('[data-orp-dds]');
    const bardd = q('[data-orp-bardd]');
    function renderDropdowns() {
      if (dds) dds.innerHTML = DDI.map((i) => ddHTML(i, 'm')).join('');
      if (bardd) bardd.innerHTML = DDI.length === 1 ? ddHTML(DDI[0], 'b') : '';
    }
    new MutationObserver((list) => {
      let changed = false;
      list.forEach((m) => {
        const li = m.target;
        if (!(li instanceof HTMLElement) || li.getAttribute('aria-selected') !== 'true') return;
        const dd = li.closest('[data-orp-dd]');
        if (!dd) return;
        const i = +dd.dataset.orpDd;
        const v = dd.querySelector('.ora-dd__v');
        if (v) { v.classList.remove('is-ph'); v.textContent = li.dataset.v; }
        dd.querySelector('.ora-dd__btn')?.setAttribute('aria-label', `${OPTS[i].l}: ${li.dataset.v}`);
        if (S.sz[i] !== li.dataset.v) { S.sz[i] = li.dataset.v; changed = true; }
      });
      if (changed) { qa('[data-orp-dd]').forEach((d) => d.classList.remove('is-miss')); msg(''); update(); }
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });

    /* ---------- messaggi ---------- */
    const msgEl = q('[data-orp-msg]');
    let msgT = 0;
    function msg(t, ms) { clearTimeout(msgT); msgEl.textContent = t; if (ms) msgT = setTimeout(() => { if (msgEl.textContent === t) msgEl.textContent = ''; }, ms); }

    /* ---------- prezzo ---------- */
    const priceEl = q('[data-orp-price]');
    function priceOf() {
      const v = current();
      if (v) return v;
      const vs = vOfColor(S.c);
      const pool = vs.filter((x) => x.a).length ? vs.filter((x) => x.a) : vs;
      return pool.reduce((m, x) => (!m || x.p < m.p ? x : m), null);
    }
    function paintPrice() {
      const v = priceOf();
      if (!v) return;
      const off = v.cp && v.cp > v.p;
      const html = esc(money(v.p)) + (off ? `<s class="ors-cmp">${esc(money(v.cp))}</s>` : '');
      if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
      q('[data-orp-barn]').innerHTML = (off ? `<s class="ors-cmp">${esc(money(v.cp))}</s> ` : '') + esc(money(v.p));
      const ofr = q('[data-orp-offer]');
      if (ofr) { ofr.hidden = !off; if (off) ofr.querySelector('[data-orp-offerp]').innerHTML = `<s class="ors-cmp">${esc(money(v.cp))}</s><b>${esc(money(v.p))}</b>`; }
    }

    /* ---------- aggiornamento generale ---------- */
    const atc = q('[data-orp-atc]');
    function update() {
      if (typeof refreshUp === 'function' && matchRows) refreshUp();
      const v = current();
      const sv = q('[data-orp-sv]');
      if (sv) {
        const chosen = DDI.filter((i) => S.sz[i] != null);
        sv.textContent = !chosen.length ? 'Da scegliere' : DDI.length === 1 ? 'Taglia ' + S.sz[DDI[0]] : chosen.length === DDI.length ? 'Scelte' : `${chosen.length} di ${DDI.length}`;
      }
      const colorOut = !vOfColor(S.c).some((x) => x.a);
      const out = colorOut || (v && !v.a);
      atc.disabled = out || busy;
      q('[data-orp-barb]').disabled = out || busy;
      q('[data-orp-atct]').textContent = busy ? 'Aggiunta in corso' : out ? T.soldOut : T.add;
      paintPrice();
      if (v && history.replaceState) {
        const u = new URL(location.href);
        if (u.searchParams.get('variant') !== String(v.id)) { u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); }
      }
      renderRes();
      paintTable();
    }

    function setColor(c) {
      S.c = c;
      DDI.forEach((i) => { if (S.sz[i] != null && !availVal(c, i, S.sz[i])) delete S.sz[i]; });
      qa('[data-orp-cols] button').forEach((b) => b.setAttribute('aria-pressed', String(COLS[+b.dataset.k].n === c)));
      const cv = q('[data-orp-cv]');
      if (cv) cv.textContent = c || '';
      FR = framesFor(c);
      S.vi = 0;
      renderViews();
      setView(0);
      FR.forEach((f) => { const im = new Image(); im.src = f.u; });
      renderDropdowns();
      // barra fissa e scheda tecnica
      const f0 = FR[0];
      if (f0) q('[data-orp-barim]').src = f0.t;
      q('[data-orp-bart]').textContent = [D.title, c].filter(Boolean).join(' · ');
      const det = q('[data-orp-det]:not([data-tex]) img');
      if (det && f0) { det.removeAttribute('srcset'); det.src = f0.u; }
      giraColor();
      renderMatch();
      msg('');
      update();
    }

    /* ---------- aggiungi al carrello ---------- */
    let busy = false;
    function missing() { return DDI.filter((i) => S.sz[i] == null); }
    function openDD(dd) {
      const btn = dd && dd.querySelector('.ora-dd__btn');
      if (btn && !dd.classList.contains('ora-dd--open')) btn.click();
    }
    async function add(fromBar) {
      if (busy) return;
      const miss = missing();
      if (miss.length) {
        qa('[data-orp-dd]').forEach((d) => d.classList.toggle('is-miss', miss.includes(+d.dataset.orpDd)));
        msg(T.miss);
        const first = dds && dds.querySelector(`[data-orp-dd="${miss[0]}"]`);
        if (!first) return;
        if (fromBar && DDI.length === 1) { openDD(bardd.querySelector('[data-orp-dd]')); return; }
        const r = first.getBoundingClientRect();
        const hidden = r.top < 90 || r.bottom > innerHeight - 110;
        if (hidden) first.scrollIntoView({ behavior: REDUCED.matches ? 'auto' : 'smooth', block: 'center' });
        setTimeout(() => openDD(first), hidden ? 520 : 0);
        return;
      }
      const v = current();
      if (!v || !v.a) { msg(T.soldOut); return; }
      busy = true;
      update();
      const ids = Array.from(document.querySelectorAll('cart-items-component')).map((e) => e.dataset.sectionId).filter(Boolean);
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: ids.join(',') }) }).then((r) => r.json());
        if (res.status) { msg(res.description || res.message || 'Non disponibile'); return; }
        const cart = await fetch(base + 'cart.js').then((r) => r.json());
        msg(T.added, 2500);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ora-prodotto', data: { source: 'ora-prodotto', itemCount: cart.item_count, sections: res.sections } } }));
      } catch (e) {
        msg('Riprova tra poco');
      } finally {
        busy = false;
        update();
      }
    }
    atc.addEventListener('click', () => add(false));
    q('[data-orp-barb]').addEventListener('click', () => add(true));

    /* ---------- si abbina a ---------- */
    const matchEl = q('[data-orp-match]');
    function thumbFor(item, c) {
      const vs = item.v.filter((v) => low(v.c) === low(c));
      const vm = vs.find((v) => v.m);
      if (vm) return vm.m;
      let best = null, len = 0;
      item.m.forEach((m) => { const h = colorHit(m.k, c); if (h > len) { len = h; best = m; } });
      if (best) return best.t;
      const s = setFor(c);
      return s && s.m[0] ? s.m[0].t : '';
    }
    function renderMatch() {
      if (!matchEl) return;
      const c = S.c;
      const rows = [];
      if (c) {
        D.pieces.forEach((p) => {
          const vs = p.v.filter((v) => low(v.c) === low(c));
          if (!vs.length) return;
          const va = vs.find((v) => v.a) || vs[0];
          const pr = Math.min(...vs.map((v) => v.p));
          rows.push({ pc: p, t: p.t, sub: vs.some((v) => v.a) ? c : c + ', esaurito', u: p.u + '?variant=' + va.id, p: pr, im: thumbFor(p, c), sz: vs.map((v) => ({ id: v.id, s: v.s, a: v.a, p: v.p })).filter((v) => v.s) });
        });
        rows.splice(2);
        const s = setFor(c);
        if (s) {
          const base = s.t.replace(new RegExp('\\s+' + c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i'), '');
          rows.push({ t: base, sub: s.a ? c : c + ', esaurito', u: s.u, p: s.p, im: s.m[0] ? s.m[0].t : '' });
        }
      }
      matchRows = rows;
      matchEl.innerHTML = rows
        .map((r, i) => {
          const head = `${r.im ? `<img src="${esc(r.im)}" alt="" width="36" height="48" loading="lazy">` : '<span class="ors-mt-ph" aria-hidden="true"></span>'}<span class="ors-mt-t"><b>${esc(r.t)}</b><small>${esc(r.sub)}</small></span><span class="ors-mt-p">${esc(money(r.p))}</span>`;
          if (r.sz && r.sz.length) {
            const zoom = `<button type="button" class="orp-up-zoom" data-zoom="${i}" aria-label="Ingrandisci la foto di ${esc(r.t)}">${r.im ? `<img src="${esc(r.im)}" alt="" width="44" height="58" loading="lazy">` : ''}<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M10.5 8v5M8 10.5h5"/></svg></button>`;
            return `<li class="orp-up" data-row="${i}"><div class="orp-up-h">${zoom}<span class="ors-mt-t"><b>${esc(r.t)}</b><small>${esc(r.sub)}</small></span><span class="ors-mt-p">${esc(money(r.p))}</span></div>
              <div class="orp-up-s" role="group" aria-label="Taglia ${esc(r.t)}">${r.sz.map((z) => `<button type="button" data-us="${z.id}" data-s="${esc(z.s)}" data-p="${z.p}"${z.a ? '' : ' disabled'} aria-pressed="${upSel[i] == z.id}">${esc(z.s)}</button>`).join('')}</div>
              <div class="orp-up-a"><button type="button" class="orp-up-both" data-both="${i}"></button><p class="orp-up-d" data-upd></p><button type="button" class="orp-up-solo" data-solo="${i}">Aggiungi solo ${esc(r.t)}</button></div>
              <p class="orp-up-m" aria-live="polite"></p></li>`;
          }
          return `<li><a href="${esc(r.u)}">${head}${GO}</a></li>`;
        })
        .join('');
      q('[data-orp-mtw]').hidden = !rows.length;
      refreshUp();
    }

    /* ---------- si abbina a: foto ingrandita e aggiunta insieme al capo della pagina ---------- */
    var matchRows, upSel = {};
    const qRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const zm = document.createElement('dialog');
    zm.className = 'orp-zoom';
    zm.setAttribute('aria-label', 'Foto ingrandita');
    document.body.appendChild(zm);
    zm.addEventListener('click', () => zm.close());
    function bigOf(r) {
      const m = r.pc && r.pc.m.find((x) => x.t === r.im);
      return m ? m.u : String(r.im || '').replace(/width=\d+/, 'width=1400');
    }
    function mainSize() { return DDI.length === 1 && S.sz[DDI[0]] != null ? String(S.sz[DDI[0]]) : ''; }
    function refreshUp() {
      if (!matchEl) return;
      const v = current(), ms = mainSize();
      matchEl.querySelectorAll('.orp-up').forEach((li) => {
        const i = +li.dataset.row, r = matchRows && matchRows[i]; if (!r) return;
        const sel = li.querySelector(`[data-us="${upSel[i]}"]`);
        const both = li.querySelector('[data-both]'), d = li.querySelector('[data-upd]'), solo = li.querySelector('[data-solo]');
        const pp = sel ? +sel.dataset.p : r.p;
        const tot = (v ? v.p : Math.min(...vOfColor(S.c).map((x) => x.p))) + pp;
        both.textContent = `Aggiungi entrambi · ${money(tot)}`;
        solo.disabled = !sel;
        if (!sel) d.textContent = `Scegli la taglia di ${r.t}.`;
        else if (!ms) d.textContent = `${r.t} taglia ${sel.dataset.s}. Scegli anche la tua taglia di ${D.title} qui sopra.`;
        else d.textContent = `${D.title} taglia ${ms} e ${r.t} taglia ${sel.dataset.s}, insieme nel carrello.`;
        both.disabled = !sel;
      });
    }
    function cartAdd(items) {
      return fetch(qRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
        .then((x) => { if (!x.ok) throw x; return fetch(qRoot + 'cart.js'); }).then((x) => x.json())
        .then((cart) => { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ora-upsell', data: { source: 'ora-upsell', itemCount: cart.item_count } } })); return cart; });
    }
    if (matchEl) matchEl.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (z) { const r = matchRows[+z.dataset.zoom]; zm.innerHTML = `<img src="${esc(bigOf(r))}" alt="${esc(r.t)}, ${esc(S.c || '')}"><button type="button" class="orp-zoom-x" aria-label="Chiudi"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`; zm.showModal(); return; }
      const li = e.target.closest('.orp-up'); if (!li) return;
      const i = +li.dataset.row, r = matchRows[i], m = li.querySelector('.orp-up-m');
      const us = e.target.closest('[data-us]');
      if (us && !us.disabled) {
        upSel[i] = us.dataset.us;
        li.querySelectorAll('[data-us]').forEach((x) => x.setAttribute('aria-pressed', String(x === us)));
        m.textContent = ''; refreshUp(); return;
      }
      const sel = li.querySelector(`[data-us="${upSel[i]}"]`);
      if (e.target.closest('[data-solo]') && sel) {
        m.textContent = 'Aggiungo…';
        cartAdd([{ id: +sel.dataset.us, quantity: 1 }]).then(() => { m.textContent = `${r.t} taglia ${sel.dataset.s} aggiunto al carrello.`; }).catch(() => { m.textContent = 'Non è stato possibile aggiungerlo. Riprova.'; });
        return;
      }
      if (e.target.closest('[data-both]') && sel) {
        if (missing().length) { m.textContent = `Scegli la tua taglia di ${D.title}: si è aperto il menu qui sopra.`; add(false); return; }
        const v = current();
        if (!v || !v.a) { m.textContent = `${D.title} in questa taglia è esaurito. Scegline un'altra qui sopra.`; return; }
        const bt = li.querySelector('[data-both]'); bt.disabled = true; m.textContent = 'Aggiungo…';
        cartAdd([{ id: v.id, quantity: 1 }, { id: +sel.dataset.us, quantity: 1 }])
          .then(() => { m.textContent = `Aggiunti al carrello: ${D.title} taglia ${mainSize()} e ${r.t} taglia ${sel.dataset.s}.`; })
          .catch(() => { m.textContent = 'Non è stato possibile aggiungerli. Riprova.'; })
          .finally(() => { bt.disabled = false; });
      }
    });

    /* ---------- barra fissa: compare solo dopo aver superato il bottone principale ---------- */
    const bar = q('[data-orp-bar]');
    let barOn = null, barRaf = 0;
    function showBar(o) {
      bar.classList.toggle('is-on', o);
      bar.setAttribute('aria-hidden', String(!o));
      bar.inert = !o;
      document.documentElement.classList.toggle('ors-has-bar', o);
      if (!o) bar.querySelectorAll('.ora-dd--open .ora-dd__btn').forEach((b) => b.click());
    }
    function barCheck() {
      barRaf = 0;
      const hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 72;
      const o = atc.getBoundingClientRect().bottom < hh;
      if (o !== barOn) { barOn = o; showBar(o); }
    }
    const barSched = () => { if (!barRaf) barRaf = requestAnimationFrame(barCheck); };
    addEventListener('scroll', barSched, { passive: true });
    addEventListener('resize', barSched);

    /* ---------- pannello Descrizione ---------- */
    const dlg = q('[data-orp-desc]');
    const opener = q('[data-orp-desc-open]');
    if (dlg && opener) {
      // il pannello sta fuori dal contenuto (niente trasformazioni o sticky che lo taglino)
      document.body.appendChild(dlg);
      opener.addEventListener('click', () => { dlg.showModal(); document.documentElement.classList.add('orp-lock'); dlg.querySelector('.ora-guide__x')?.focus(); });
      dlg.addEventListener('close', () => { document.documentElement.classList.remove('orp-lock'); opener.focus({ preventScroll: true }); });
    }

    /* ---------- colonna sinistra: sticky solo se ci sta ---------- */
    const left = q('[data-orp-left]');
    function stickyFit() {
      left.classList.remove('is-static');
      const hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 72;
      if (innerWidth >= 1280 && left.offsetHeight > innerHeight - hh - 32) left.classList.add('is-static');
    }

    /* ---------- gira ---------- */
    const gira = q('[data-orp-gira]');
    const viewer = q('[data-orp-viewer]');
    let GF = [], gi = 0, used = false, intro = 0;
    function dialSVG() {
      const dial = q('[data-orp-dial]');
      const a = GF.map((f) => f.deg);
      const mn = Math.min(...a), mx = Math.max(...a);
      let t = '<circle cx="64" cy="64" r="56" fill="none" stroke="#000" stroke-width="1"/>';
      for (let d = 0; d < 360; d += 15) {
        const s = d > 180 ? d - 360 : d;
        const on = s >= mn - 0.1 && s <= mx + 0.1;
        const lg = d % 90 === 0;
        const rad = ((d - 90) * Math.PI) / 180;
        const r1 = 56, r2 = lg ? 46 : 51;
        t += `<line x1="${(64 + r1 * Math.cos(rad)).toFixed(2)}" y1="${(64 + r1 * Math.sin(rad)).toFixed(2)}" x2="${(64 + r2 * Math.cos(rad)).toFixed(2)}" y2="${(64 + r2 * Math.sin(rad)).toFixed(2)}" stroke="${on ? '#000' : '#c8c8c8'}" stroke-width="${on ? 1.4 : 1}"/>`;
      }
      const retro = a.some((x) => Math.abs(x) >= 150);
      t += `<text x="64" y="-6" text-anchor="middle" fill="#000">FRONTE</text><text x="64" y="140" text-anchor="middle" fill="${retro ? '#000' : '#8a8a8a'}">RETRO</text>`;
      t += '<g class="nd" data-orp-nd><line x1="64" y1="64" x2="64" y2="20" stroke="#000" stroke-width="2"/></g><rect x="60" y="60" width="8" height="8" fill="#000"/>';
      dial.innerHTML = t;
    }
    function giraColor() {
      if (!gira) return;
      const seen = {};
      GF = FR.filter((f) => f.deg !== null && !seen[f.k] && (seen[f.k] = 1)).slice().sort((x, y) => x.deg - y.deg);
      gira.hidden = GF.length < 3;
      if (GF.length < 3) return;
      q('[data-orp-vimgs]').innerHTML = GF.map((f) => `<img src="${esc(f.u)}" alt="" draggable="false">`).join('');
      q('[data-orp-strip]').innerHTML = GF.map((f, i) => `<button type="button" data-gi="${i}" aria-label="${esc(f.label)}"><span class="th"><img src="${esc(f.t)}" alt="" draggable="false" loading="lazy"></span><span>${esc(f.label)}</span></button>`).join('');
      dialSVG();
      const z = GF.findIndex((f) => f.deg === 0);
      gset(z > -1 ? z : 0);
    }
    function gset(i) {
      const n = GF.length;
      if (!n) return;
      gi = ((i % n) + n) % n;
      const f = GF[gi];
      qa('[data-orp-vimgs] img').forEach((im, k) => im.classList.toggle('is-on', k === gi));
      const nd = q('[data-orp-nd]');
      if (nd) nd.style.transform = `rotate(${f.deg}deg)`;
      q('[data-orp-gn]').textContent = f.label;
      q('[data-orp-gc]').textContent = `${gi + 1} di ${n}`;
      qa('[data-orp-strip] button').forEach((b, k) => { b.classList.toggle('is-on', k === gi); b.setAttribute('aria-pressed', String(k === gi)); });
      q('[data-orp-tb]').style.left = ((gi + 0.5) / n) * 100 + '%';
      viewer.setAttribute('aria-label', `${D.title}${S.c ? ' ' + S.c : ''}, vista ${f.label}. Usa le frecce per girare.`);
    }
    function markUsed() { used = true; viewer.classList.add('is-used'); clearInterval(intro); intro = 0; }
    if (gira) {
      let x0 = 0, g0 = 0, drag = false;
      viewer.addEventListener('pointerdown', (e) => {
        markUsed(); drag = true; x0 = e.clientX; g0 = gi;
        viewer.classList.add('is-drag');
        try { viewer.setPointerCapture(e.pointerId); } catch (_) { /* niente */ }
      });
      viewer.addEventListener('pointermove', (e) => {
        if (!drag || !GF.length) return;
        const step = viewer.clientWidth / (GF.length + 1);
        const k = Math.trunc((x0 - e.clientX) / step);
        const n = GF.length;
        if ((((g0 + k) % n) + n) % n !== gi) gset(g0 + k);
      });
      const end = () => { drag = false; viewer.classList.remove('is-drag'); };
      viewer.addEventListener('pointerup', end);
      viewer.addEventListener('pointercancel', end);
      viewer.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); markUsed(); gset(gi + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); markUsed(); gset(gi - 1); }
      });
      const pickAt = (el, x) => { const r = el.getBoundingClientRect(); gset(Math.max(0, Math.min(GF.length - 1, Math.floor(((x - r.left) / r.width) * GF.length)))); };
      [q('[data-orp-strip]'), q('[data-orp-track]')].forEach((el) => {
        let on = false;
        el.addEventListener('pointerdown', (e) => { markUsed(); on = true; pickAt(el, e.clientX); try { el.setPointerCapture(e.pointerId); } catch (_) { /* niente */ } });
        el.addEventListener('pointermove', (e) => { if (on) pickAt(el, e.clientX); });
        el.addEventListener('pointerup', () => { on = false; });
        el.addEventListener('pointercancel', () => { on = false; });
      });
      q('[data-orp-strip]').addEventListener('keydown', (e) => { const b = e.target.closest('button[data-gi]'); if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); markUsed(); gset(+b.dataset.gi); } });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          if (used || REDUCED.matches || GF.length < 3) return;
          const start = Math.max(0, GF.findIndex((f) => f.deg === 0));
          const seq = [];
          for (let k = 1; k <= GF.length; k++) seq.push((start + k) % GF.length);
          let s = 0;
          intro = setInterval(() => {
            if (used) { clearInterval(intro); return; }
            gset(seq[s++]);
            if (s >= seq.length) { clearInterval(intro); intro = 0; }
          }, 520);
        }, { threshold: 0.6 });
        io.observe(viewer);
      }
    }

    /* ---------- tu e la modella, misure (solo con dati veri) ---------- */
    const SZ = DDI.length ? OPTS[DDI[0]].v : [];
    let MODEL = null;
    const mm = String(D.modelInfo || '').match(/(\d{3})\s*cm/i);
    const ms = String(D.modelInfo || '').match(/taglia\s+([A-Za-z0-9]{1,4})\b/i);
    if (mm && ms) MODEL = { h: +mm[1], s: ms[1].toUpperCase(), txt: String(D.modelInfo) };
    const cell = (x) => { const n = String(x || '').match(/\d+(?:[.,]\d+)?/g); if (!n) return nodash(x); return n.length >= 2 ? `da ${n[0]} a ${n[1]}` : n[0]; };
    let CHART = null;
    if (D.sizeChart) {
      // come la pagina set: prima riga Misura | S | M | L, poi Seno | 80 84 | ...
      const rows = String(D.sizeChart).split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((r) => r.length >= 2 && r[0]);
      if (rows.length >= 2) CHART = { head: rows[0], rows: rows.slice(1) };
    }
    let usual = null, hl = null, me = 165;
    const modelEl = q('[data-orp-model]'), chartEl = q('[data-orp-chart]'), duo = q('[data-orp-duo]');
    if (modelEl && MODEL) {
      modelEl.hidden = false;
      q('[data-orp-model-t]').textContent = `La modella è alta ${MODEL.h} cm e indossa la taglia ${MODEL.s}.`;
      q('[data-orp-mdbar]').style.height = (MODEL.h / 200) * 100 + '%';
      q('[data-orp-mdv]').textContent = MODEL.h + ' cm';
      q('[data-orp-seg]').innerHTML = SZ.map((s) => `<button type="button" data-s="${esc(s)}" aria-pressed="false">${esc(s)}</button>`).join('');
      q('[data-orp-seg]').addEventListener('click', (e) => {
        const b = e.target.closest('button[data-s]');
        if (!b) return;
        usual = b.dataset.s;
        qa('[data-orp-seg] button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        hl = usual;
        paintTable();
        renderRes();
      });
      const hin = q('[data-orp-hin]');
      const paintMe = () => { q('[data-orp-mebar]').style.height = (me / 200) * 100 + '%'; q('[data-orp-mev]').textContent = me + ' cm'; renderRes(); };
      const setMe = (v) => { me = Math.max(140, Math.min(200, Math.round(v) || 165)); hin.value = me; paintMe(); };
      q('[data-orp-hm]').addEventListener('click', () => setMe(me - 1));
      q('[data-orp-hp]').addEventListener('click', () => setMe(me + 1));
      hin.addEventListener('change', () => setMe(+hin.value));
      hin.addEventListener('input', () => { const v = +hin.value; if (v >= 140 && v <= 200) { me = v; paintMe(); } });
      q('[data-orp-res]').addEventListener('click', (e) => {
        if (!e.target.closest('[data-orp-use]') || !usual || !DDI.length) return;
        const i = DDI[0];
        if (!availVal(S.c, i, usual)) return;
        const li = dds && dds.querySelector(`[data-orp-dd="${i}"] [data-v="${CSS.escape(usual)}"]`);
        if (li) li.click();
      });
      setMe(165);
    }
    if (chartEl && CHART) {
      chartEl.hidden = false;
      const h = CHART.head;
      q('[data-orp-szt]').innerHTML = `<thead><tr>${h.map((c, k) => `<th scope="col"${k ? ` data-c="${esc(c)}"` : ''}>${k ? esc(nodash(c)) : 'cm'}</th>`).join('')}</tr></thead><tbody>${CHART.rows
        .map((r) => `<tr>${h.map((c, k) => `<td${k ? ` data-c="${esc(c)}"` : ''}>${esc(k ? cell(r[k]) : nodash(r[k] || ''))}</td>`).join('')}</tr>`)
        .join('')}</tbody>`;
    }
    if (duo) {
      const on = [modelEl && !modelEl.hidden, chartEl && !chartEl.hidden].filter(Boolean).length;
      duo.hidden = !on;
      duo.classList.toggle('is-one', on === 1);
      const go = q('[data-orp-go]');
      if (go) {
        const gm = modelEl && !modelEl.hidden, gc = chartEl && !chartEl.hidden;
        q('[data-orp-go-m]').hidden = !gm;
        q('[data-orp-go-c]').hidden = !gc;
        q('[data-orp-go-s]').hidden = !(gm && gc);
        go.hidden = !(gm || gc);
      }
    }
    function renderRes() {
      const res = q('[data-orp-res]');
      if (!res || !MODEL) return;
      const d = me - MODEL.h;
      const h = d === 0 ? `Sei alta ${me} cm, come la modella.` : `Sei alta ${me} cm, ${Math.abs(d)} cm ${d < 0 ? 'meno' : 'più'} della modella.`;
      let a = '<p>Scegli la taglia che porti di solito per il consiglio.</p>';
      let btn = '';
      if (usual) {
        const adv = String(D.sizeAdvice || '').replace(/[,.]?\s*scegli la tua taglia abituale\.?$/i, '').trim();
        a = `<p>${esc(adv ? adv + ': ti consigliamo' : 'Ti consigliamo')} la tua taglia abituale, la ${esc(usual)}.</p>`;
        if (DDI.length && !availVal(S.c, DDI[0], usual)) btn = `<p>La ${esc(usual)} non è disponibile${S.c ? ' in ' + esc(S.c) : ''}.</p>`;
        else if (DDI.length) btn = S.sz[DDI[0]] === usual ? `<button type="button" class="ors-btn ors-btn--ol" data-orp-use aria-pressed="true">Taglia ${esc(usual)} scelta</button>` : `<button type="button" class="ors-btn ors-btn--ol" data-orp-use>Scegli la ${esc(usual)}</button>`;
      }
      res.innerHTML = `<p>${h}</p>${a}${btn}`;
    }
    function paintTable() {
      if (!CHART) return;
      const k = hl || (DDI.length ? S.sz[DDI[0]] : null);
      qa('[data-orp-szt] [data-c]').forEach((c) => c.classList.toggle('is-hl', !!k && low(c.dataset.c) === low(k)));
    }

    /* ---------- avvio ---------- */
    renderColors();
    setColor(S.c);
    barCheck();
    stickyFit();
    addEventListener('resize', stickyFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(stickyFit);
    if (window.OraPref && window.OraPref.aggiorna) window.OraPref.aggiorna();
  }

  const start = () => document.querySelectorAll('[data-ora-prod]').forEach((r) => { if (!r.dataset.orpReady) { r.dataset.orpReady = '1'; try { init(r); } catch (e) { console.error('ORA prodotto', e); } } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
